import React from 'react'

const CouponIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.666 13.334V17.334M34.666 26.6673V37.334M34.666 46.6673V50.6673"
        stroke="#2E3860"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56 16.0007V48.0006C56 48.7079 55.7191 49.3862 55.219 49.8863C54.7189 50.3864 54.0406 50.6673 53.3333 50.6673H10.6667C9.95942 50.6673 9.28115 50.3864 8.78105 49.8863C8.28095 49.3862 8 48.7079 8 48.0006V40.0006C10.1217 40.0006 12.1566 39.1578 13.6569 37.6575C15.1571 36.1572 16 34.1224 16 32.0006C16 29.8789 15.1571 27.8441 13.6569 26.3438C12.1566 24.8435 10.1217 24.0007 8 24.0007V16.0007C8 15.2934 8.28095 14.6151 8.78105 14.115C9.28115 13.6149 9.95942 13.334 10.6667 13.334H53.3333C54.0406 13.334 54.7189 13.6149 55.219 14.115C55.7191 14.6151 56 15.2934 56 16.0007Z"
        stroke="#2E3860"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CouponIcon
